<template>
  <vue-final-modal
    :classes="'modal-container ' + (dockPosition ? 'docked ' : '') + classDetail"
    content-class="modal-content "
    v-slot="{ close }"
    v-bind="$attrs"
    :esc-to-close="escToClose"
    :drag="isDrag"
    :resize="resize"
    :content-style="styles"
    :click-to-close="false"
    drag-selector=".modal__title"
    class="ms-dynamic-popup"
    :transition="{
      'enter-active-class': '.3s cubic-bezier(.25,.8,.25,1)',
      'enter-class': 'translate-y-full',
      'enter-to-class': 'translate-y-0',
      'leave-active-class': 'transition duration-200 ease-in-out transform',
      'leave-to-class': 'translate-y-full',
      'leave-class': 'translate-y-0',
    }"
    :name="name"
    :hideOverlay="hideOverlay"
    @resize:move="onResizeMove"
    :min-width="200"
    :min-height="200"
  >
    <div class="fake-click-popup"></div>
    <div
      class="maximum-button toggle-above-resize"
      :class="[{ 'arrow-right': maximum }, { 'arrow-left': !maximum }]"
      v-if="dockPosition && resizeIcon"
      @click="maximumClick"
    ></div>
    <div v-if="showTitle" class="modal__title" :class="[{ modal__drag: isDrag }, classTitle]">
      <div class="title-left">
        <span class="title" @click="redirectClick" :title="isShowTooltip ? title: ''">{{ title }}</span>
        <slot name="content-title"></slot>
      </div>
      <div class="title-right">
        <slot name="icon"></slot>

        <div
          v-if="maximumable"
          @click="maximumClick"
          class="button icon24"
          :class="['button', maximum ? 'restore' : 'maximum']"
        ></div>
        <div
          v-if="isShowClose"
          class="button icon24 close"
          @click="close"
          shortkey-target="Close"
          v-tooltip="'Đóng cửa sổ (ESC)'"
        ></div>
      </div>
    </div>
    <div class="modal__content flex-column flex1">
      <span class="popup-shortkey" @shortkey="shortkeyAction" v-shortkey="defaultShortKey"></span>

      <slot name="content" :close="close"></slot>
    </div>
    <div class="modal__footer" v-if="$slots['footer']">
      <slot name="footer" :close="close"></slot>
    </div>
  </vue-final-modal>
</template>

<script>
import { shortkeyStatusbar } from '@/mixins/common/shortkeyStatusbar';
import popupUtil from '@/commons/popupUtil';
export default {
  name: 'MsDynamicPopup',
  mixins: [shortkeyStatusbar],
};
</script>
<script setup>
import { defineProps, computed, getCurrentInstance, watchEffect, onMounted, onUnmounted, ref } from 'vue';
const { proxy } = getCurrentInstance();
const emit = defineEmits(['shortkeyAction', 'redirectClick']);
const props = defineProps({
  dragable: {
    type: Boolean,
    default: true,
  },
  resize: {
    type: Boolean,
    default: false,
  },
  // icon resize ở mép
  resizeIcon: {
    type: Boolean,
    default: false,
  },
  // hiện title
  showTitle: {
    type: Boolean,
    default: true,
  },
  width: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: '',
  },
  maximum: {
    type: Boolean,
    default: false,
  },
  /**
   * Có hiển thị icon maxixum không
   */
  maximumable: {
    type: Boolean,
    default: false,
  },

  /**
   * Có hiển thị nút X hay không
   * DVMINH 09/01/2023
   */
  isShowClose: {
    type: Boolean,
    default: true,
  },
  params: {
    type: Object,
    default: () => {},
  },
  classTitle: {
    type: String,
    default: '',
  },
  dockPosition: {
    type: String,
    default: null,
  },

  /**
   * Định nghĩa shortKey
   */
  shortkey: {
    default: null,
    type: [String, Object],
  },

  /**
   * class root
   */
  classDetail: {
    default: null,
    type: String,
  },
  name: {
    default: null,
    type: String,
  },
  hideOverlay: {
    default: false,
    type: Boolean,
  },
  /**
   * Hiển thị button mở shortkeyDetailPopup
   * TVDAT 21/11/2022
   */
  isShowShortkey: {
    default: true,
    type: Boolean,
  },
  /** Nhấn Esc để đóng form */
  escToClose: {
    default: true,
    type: Boolean,
  },
  /**
   * Có show tooltip trên thanh tiêu đề không (trường hợp tiêu đề dài quá)
   * NHANH3 30.05.2024
   */
  isShowTooltip: {
    default: false,
    type: Boolean,
  }
});
let shortkey = {
  Close: ['esc'], //Đóng
  Save: ['ctrl', 's'], //Cất
  SaveAndAdd: ['ctrl', 'shift', 's'], //Cất và thêm
  Help: ['f1'], //Giúp
  Print: ['ctrl', 'p'], //IN
  Maximum: ['ctrl', 'space'], //phóng to thu nhỏ form
  QuickSelect: ['f3'], //chọn nhanh
  ArrowLeft: ['alt', 'b'], //back chứng từ
  ArrowRight: ['alt', 'n'], //next chứng từ
  Postpone: ['ctrl', 'u'], //hoãn
  Edit: ['ctrl', 'e'], // sửa
  Refresh: ['ctrl', 'r'], //load lại grid
  Delete: ['ctrl', 'd'], //xóa
  Duplicate: ['ctrl', 'shift', 'c'], //nhân bản
  Posted: ['ctrl', 'g'], //Ghi sổ
  UnPosted: ['ctrl', 'b'], //Ghi sổ
  InsertRowGrid: ['ctrl', 'insert'],
  DeleteRowGrid: ['ctrl', 'del'],
  Add: ['ctrl', '1'],
  Cancel: ['ctrl', 'h'],
  Quit: ['ctrl', 'q'],
  ViewAccount: ['ctrl', '3'], //Xem số dư tài khoản
  Approve: ['f7'], //Duyệt
  ViewQuantity: ['ctrl', 'f2'], //Xem số tồn vật tư hàng hóa
  QuickAdd: ['f9'], //Thêm nhanh chứng từ
  CopyVoucher: ['ctrl', '/'], //Sao chép chứng từ
  ConfigLayout: ['ctrl', '*'], //Tùy chỉnh giao diện
  SyncSearchVoucher: ['ctrl', 'alt', 'g'], //Đồng bộ tìm kiếm
  SyncSearchVoucherV2: ['ctrl', 'alt', 'h'], //Đồng bộ tìm kiếm theo thủ tục
};
const defaultShortKey = computed(() => {
  if (props.shortkey) return props.shortkey;
  return shortkey;
});
const isDrag = computed(() => {
  if (props.maximum) return false;

  if (props.dockPosition) return false;
  return props.dragable !== false;
});

const resizeOn = ref(false);
const onResizeMove = () => {
  resizeOn.value = true;
  //Emit sự kiện sau khi thực hiện kéo thả độ rộng popup
  proxy.$emit('afterResize');
};
const styles = computed(() => {
  let style = {};
  if (props.width) style.width = `${props.width}px`;

  if (props.height) style.height = `${props.height}px`;
  
  if (props.maximum) {
    style.width = '100%';
    style.height = '100vh';
    style.top = 0;
    style.left = 0;
  }
  if (resizeOn.value) {
    style = {};
  }

  if (props.dockPosition) {
    style.height = '100vh';
    switch (props.dockPosition) {
      case 'left':
        style.left = 0;
        break;
      case 'right':
        if(props.maximum == false && !resizeOn.value && props.resize == true){
          //NNLINH sửa trường hợp vừa kéo thả vừa max min
          style.left = `calc(100% - ${props.width}px)`;
        }
        style.right = 0;
        break;
    }
  }
  return style;
});

/**
 * Push el để xử lý shortkey cho view
 */
onMounted(() => {
  proxy.$ms.commonFn.shortkeyPushView(proxy.$el);
});

/**
 * Loại bỏ el dùng cho shortkey
 */
onUnmounted(() => {
  proxy.$ms.commonFn.shortkeyPopView(proxy.$el);
});
/**
 * emit event click title
 * bnanh 01.07.2022
 */
const redirectClick = () => {
  emit('redirectClick');
};

const maximumClick = () => {
  resizeOn.value = false;
  proxy.$emit('update:maximum', !props.maximum);
};

/**
 * emit event phím tắt
 */
const shortkeyAction = e => {
  let me = this;
  switch (e.srcKey) {
    default:
      emit('shortkeyAction', e);
      break;
  }
};
</script>

<style scoped lang="scss">
.maximum-button {
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 1;
}
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
  &.docked {
    justify-content: unset;
  }
}
:deep(.modal-content) {
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__content {
  flex: 1;
}
.modal__title {
  padding: 13px 16px 4px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    cursor: move;
  }
  .title {
    font-size: $ms-popup__title-font-size;
    font-weight: $font-weight-bold;
    color: #202104;
  }
  .button {
    cursor: pointer;
    display: inline-block;
    padding: 10px 8px;
  }

  .title-left {
    display: flex;
    align-items: center;
    .title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .title-right {
    display: flex;
    align-items: center;
  }
  .btn-guide {
    color: $blue;
    background-color: transparent;
  }
}
.modal__footer {
  height: $ms-popup__footer-height;
  padding: 0 20px;
  display: flex;
  background-color: #f5f5f5;
  z-index: 11;
  @include for_breakpoint(desktop-xl) {
    height: $ms-popup__footer-height-xl;
  }
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.toggle-above-resize {
  outline: none;
  cursor: pointer;
  top: 50%;
  left: -27px;
  width: 56px;
  height: 10px;
  rotate: 90;
  transform: rotate(90deg);
  border: none;
  background-color: $primary;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 4px;
  &:hover {
    background-color: #0790fc;
  }
  &.arrow-left {
    &:before {
      content: '';
      position: absolute;
      background: transparent url($ms-image-sprites) no-repeat;
      height: 10px;
      width: 20px;
      top: 0;
      left: 19px;
      background-position: -194px -79px !important;
    }
  }

  &.arrow-right {
    left: -23px;
    &:before {
      content: '';
      position: absolute;
      background: transparent url($ms-image-sprites) no-repeat;
      height: 10px;
      width: 20px;
      top: 0;
      left: 19px;
      background-position: -194px -55px !important;
    }
  }
}
</style>
